// v292 — Toute modale s'affiche au premier plan.
// Rendue directement dans <body>, une modale échappe aux contextes
// d'empilement de l'espace de travail (colonne conversation, tiroir Workflow,
// rail) qui pouvaient la faire passer derrière d'autres zones. Le conteneur
// transmet la classe de thème (`viq-dark` / `viq-light`) dont dépendent les
// styles existants, sans créer de boîte (display: contents).
import { useEffect, useState } from "react";
import { createPortal } from "react-dom";

function currentDark() {
  if (typeof document === "undefined") return false;
  return document.documentElement.getAttribute("data-theme") === "dark";
}

export default function ModalPortal({ children, className = "" }) {
  const [dark, setDark] = useState(currentDark);
  useEffect(() => {
    if (typeof MutationObserver === "undefined") return undefined;
    const obs = new MutationObserver(() => setDark(currentDark()));
    obs.observe(document.documentElement, { attributes: true, attributeFilter: ["data-theme"] });
    return () => obs.disconnect();
  }, []);
  if (typeof document === "undefined") return null;
  return createPortal(
    <div className={`viq-modal-portal ${dark ? "viq-dark" : "viq-light"} ${className}`.trim()}>{children}</div>,
    document.body,
  );
}
